export default __webpack_public_path__ + "static/media/logo_error.6b69d549.png";